class MainView {
  _mainView = document.querySelector('.main-window');

  toggleMainView() {
    this._mainView.classList.toggle('hide');
  }
}
export default new MainView();
